import React from "react";
import {
  Button,
  Form,
  TextField,
  Dialog
} from '@vitalsource/vstui';
import "../../styles/Error.css";
import {ErrorResponse} from "../types/StudioAPITypes";

export interface ErrorDialogProps {
  error: ErrorResponse | null;
  children: React.ReactNode;
}

const ErrorDialog = (props: ErrorDialogProps) => {

  function getDialog() {
    return (
      <Dialog className={"error"}
        title={"Something went wrong"}
        requireInteraction
        open
        primaryActionButton={{
          label: 'Reload',
          onClick: () => {
            location.reload(true);
          }
        }}
      >
        <p>A quick reload should correct the issue.</p>
        <p>If the problem persists, please contact <a className={"error__link"} href={"mailto:studio.support@vitalsource.com"}>studio.support@vitalsource.com</a></p>
      </Dialog>
    )
  }

  return(
    <div>
      {props.error ? getDialog(): ""}
      {props.children}
    </div>
  )
}

export default ErrorDialog;
